// Esegue cb alla prima interazione utente, o dopo fallbackMs se non arriva.
// Tiene script pesanti (Sentry, gtag) fuori dal critical path del first paint.
export function runOnFirstInteraction(cb: () => void, fallbackMs = 10000): void {
  if (typeof window === 'undefined') return;
  let fired = false;
  const run = () => {
    if (fired) return;
    fired = true;
    window.removeEventListener('pointerdown', run);
    window.removeEventListener('keydown', run);
    window.removeEventListener('touchstart', run);
    window.removeEventListener('scroll', run);
    cb();
  };
  window.addEventListener('pointerdown', run, { once: true });
  window.addEventListener('keydown', run, { once: true });
  window.addEventListener('touchstart', run, { once: true, passive: true });
  window.addEventListener('scroll', run, { once: true, passive: true });
  setTimeout(run, fallbackMs);
}
